function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import { useRef, useState } from 'react';
import classnames from 'classnames';
import { Text } from "../Text/Text/Text";
import { TextInput } from "../Input/TextInput/TextInput";
import { RadioInput } from "../Input/RadioInput/RadioInput";
import Calculate from "../Utility/Calculate";
import Utility from "../Utility/Utility";
import styles from "./BMICalculator.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var availableUnits = {
  standard: {
    weight: ['lbs'],
    height: ['ft', 'in']
  },
  imperial: {
    weight: ['st', 'lbs'],
    height: ['ft', 'in']
  },
  metric: {
    weight: ['kg'],
    height: ['cm']
  }
};
export var bmiCalculatorUnits = Object.keys(availableUnits);
export var BmiCalculatorDefaultProps = {
  title: 'BMI',
  units: ['standard'],
  bmiEmpty: '__._',
  accessibility: {
    unitGroupLabel: 'unit type options'
  },
  unitLabels: {
    standard: 'Standard',
    imperial: 'Imperial',
    metric: 'Metric'
  },
  weightLabel: 'Weight',
  heightLabel: 'Height',
  valueLabel: 'BMI'
};
export var BmiCalculator = function BmiCalculator(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? BmiCalculatorDefaultProps.title : _ref$title,
    _ref$units = _ref.units,
    units = _ref$units === void 0 ? BmiCalculatorDefaultProps.units : _ref$units,
    _ref$bmiEmpty = _ref.bmiEmpty,
    bmiEmpty = _ref$bmiEmpty === void 0 ? BmiCalculatorDefaultProps.bmiEmpty : _ref$bmiEmpty,
    _ref$accessibility = _ref.accessibility,
    accessibility = _ref$accessibility === void 0 ? BmiCalculatorDefaultProps.accessibility : _ref$accessibility,
    _ref$unitLabels = _ref.unitLabels,
    unitLabels = _ref$unitLabels === void 0 ? BmiCalculatorDefaultProps.unitLabels : _ref$unitLabels,
    _ref$weightLabel = _ref.weightLabel,
    weightLabel = _ref$weightLabel === void 0 ? BmiCalculatorDefaultProps.weightLabel : _ref$weightLabel,
    _ref$heightLabel = _ref.heightLabel,
    heightLabel = _ref$heightLabel === void 0 ? BmiCalculatorDefaultProps.heightLabel : _ref$heightLabel,
    _ref$valueLabel = _ref.valueLabel,
    valueLabel = _ref$valueLabel === void 0 ? BmiCalculatorDefaultProps.valueLabel : _ref$valueLabel;
  var id = useRef(Utility.generateUID('bmi-calculator'));
  var getInitialUnit = function getInitialUnit(units) {
    return units && units[0] in availableUnits ? units[0] : 'standard';
  };
  var initialUnit = getInitialUnit(units);
  var _useState = useState(initialUnit),
    _useState2 = _slicedToArray(_useState, 2),
    selectedUnit = _useState2[0],
    setSelectedUnit = _useState2[1];
  var initialWeight = availableUnits[selectedUnit].weight.map(function (unit) {
    return {
      unit: unit,
      value: null
    };
  });
  var initialHeight = availableUnits[selectedUnit].height.map(function (unit) {
    return {
      unit: unit,
      value: null
    };
  });
  var _useState3 = useState(initialWeight),
    _useState4 = _slicedToArray(_useState3, 2),
    weight = _useState4[0],
    setWeight = _useState4[1];
  var _useState5 = useState(initialHeight),
    _useState6 = _slicedToArray(_useState5, 2),
    height = _useState6[0],
    setHeight = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    bmi = _useState8[0],
    setBmi = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    resultActive = _useState10[0],
    setResultActive = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    displayResult = _useState12[0],
    setDisplayResult = _useState12[1];

  // Helpers.
  var calculate = function calculate(weightValues, heightValues) {
    var height = 0;
    var weight = 0;
    var unitReducer = function unitReducer(a, b) {
      return a + Calculate.unitConversion(b.value, b.unit);
    };
    if (heightValues.length > 1) {
      height = heightValues.reduce(unitReducer, 0);
    } else {
      height = Calculate.unitConversion(heightValues[0].value, heightValues[0].unit);
    }
    if (weightValues.length > 1) {
      weight = weightValues.reduce(unitReducer, 0);
    } else {
      weight = Calculate.unitConversion(weightValues[0].value, weightValues[0].unit);
    }
    return Calculate.calculateBMI(weight, height);
  };
  var checkResult = function checkResult(type, weight, height) {
    var weightInputsTotal = weight.length;
    var heightInputsTotal = height.length;
    var weightInputsFilled = weight.filter(function (e) {
      return e.value !== null;
    }).length;
    var heightInputsFilled = height.filter(function (e) {
      return e.value !== null;
    }).length;
    var filled = weightInputsFilled + heightInputsFilled;
    var total = weightInputsTotal + heightInputsTotal;
    switch (type) {
      case 'active':
        // Check if at least 1 of the text input it's filled.
        return filled > 0;
      case 'display':
        // Check if all the text input are filled.
        return filled >= total;
      default:
        return false;
    }
  };
  var onInputChange = function onInputChange(text, unit, type) {
    var values = type === 'weight' ? weight : height;
    var updatedValues = values.map(function (valueObj) {
      var element = valueObj;
      if (element.unit === unit) {
        element.value = text === '' ? null : Number(text);
      }
      return element;
    });
    if (type === 'weight') {
      setWeight(updatedValues);
    } else {
      setHeight(updatedValues);
    }
    var newBmi = calculate(weight, height);
    setBmi(newBmi < 100 ? parseFloat(newBmi.toFixed(1)) : 0);
    setResultActive(checkResult('active', weight, height));
    setDisplayResult(checkResult('display', weight, height));
  };
  var renderInput = function renderInput(element, index, type) {
    var keyPressed = 0;
    var inputId = "".concat(element.unit, "-").concat(index);
    return /*#__PURE__*/_jsxs("div", {
      className: styles.inputContainer,
      children: [/*#__PURE__*/_jsx("div", {
        className: classnames(styles.input, styles["input--".concat(type, "-").concat(selectedUnit)]),
        children: /*#__PURE__*/_jsx(TextInput, {
          id: inputId,
          onKeyDown: function onKeyDown(event) {
            keyPressed = event.charCode;
          },
          onChangeText: function onChangeText(text) {
            if (keyPressed !== 101 && keyPressed !== 45) {
              onInputChange(text, element.unit, type);
            }
          },
          text: element.value !== null ? "".concat(element.value) : '',
          inputAttributes: {
            type: 'number'
          },
          placeholder: ""
        })
      }), /*#__PURE__*/_jsx("label", {
        htmlFor: inputId,
        className: classnames(styles.formText, styles.unitLabel),
        children: element.unit
      })]
    }, inputId);
  };
  var renderInputs = function renderInputs() {
    return /*#__PURE__*/_jsxs("div", {
      className: styles.formFields,
      children: [/*#__PURE__*/_jsxs("fieldset", {
        className: styles.formField,
        children: [/*#__PURE__*/_jsx("legend", {
          children: /*#__PURE__*/_jsx(Text, {
            className: styles.formText,
            typog: "subhead5",
            children: weightLabel
          })
        }), /*#__PURE__*/_jsx("div", {
          className: styles.weightInputs,
          children: weight.map(function (element, index) {
            return renderInput(element, index, 'weight');
          })
        })]
      }), /*#__PURE__*/_jsxs("fieldset", {
        className: styles.formField,
        children: [/*#__PURE__*/_jsx("legend", {
          children: /*#__PURE__*/_jsx(Text, {
            className: styles.formText,
            typog: "subhead5",
            children: heightLabel
          })
        }), /*#__PURE__*/_jsx("div", {
          className: styles.heightInputs,
          children: height.map(function (element, index) {
            return renderInput(element, index, 'height');
          })
        })]
      })]
    });
  };
  var onUnitsOptionChange = function onUnitsOptionChange(optionUnit) {
    setSelectedUnit(optionUnit);
    setBmi(null);
    setResultActive(false);
    setWeight(availableUnits[optionUnit].weight.map(function (unit) {
      return {
        unit: unit,
        value: null
      };
    }));
    setHeight(availableUnits[optionUnit].height.map(function (unit) {
      return {
        unit: unit,
        value: null
      };
    }));
  };
  var renderOptions = function renderOptions(unit, index) {
    return /*#__PURE__*/_jsx(RadioInput, {
      name: "".concat(id, "-options"),
      label: unitLabels[unit],
      labelTypog: "bodycopy",
      value: unit,
      valueSelected: selectedUnit,
      onChange: onUnitsOptionChange,
      wrapperClass: styles.inputWrapper
    }, "".concat(unit, "-").concat(index));
  };
  var renderUnitsOptions = function renderUnitsOptions() {
    // Check and render only alowed unit options.
    var allowedUnits = units ? units.filter(function (unit) {
      return unit in availableUnits;
    }) : [];
    // Avoid render options if is only one.
    if (allowedUnits.length <= 1) return /*#__PURE__*/_jsx("div", {});
    var options = allowedUnits.map(renderOptions);
    return /*#__PURE__*/_jsx("div", {
      className: styles.formOptions,
      role: "radiogroup",
      "aria-label": accessibility.unitGroupLabel,
      children: options
    });
  };
  return /*#__PURE__*/_jsx("div", {
    className: styles.wrapper,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.content,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.title,
        children: /*#__PURE__*/_jsx(Text, {
          typog: "subhead2",
          children: title
        })
      }), /*#__PURE__*/_jsxs("form", {
        className: styles.form,
        children: [renderUnitsOptions(), renderInputs(), /*#__PURE__*/_jsx("div", {
          className: classnames({
            [styles.result]: true,
            [styles.resultActive]: resultActive
          }),
          children: /*#__PURE__*/_jsxs("div", {
            className: classnames(styles.resultValue),
            children: [bmi && displayResult ? bmi : bmiEmpty, /*#__PURE__*/_jsx(Text, {
              className: styles.resultSub,
              typog: "subhead2",
              children: valueLabel
            })]
          })
        })]
      })]
    })
  });
};